import {
  buildCreateTimetableApiV2TimetablingTimetablesPostPath,
  buildCreateTimetableStructureApiV2TimetablingStructuresPostPath,
  buildDeleteTimetableApiV2TimetablingTimetablesTimetableIdDeletePath,
  buildDeleteTimetableStructureApiV2TimetablingStructuresStructureIdDeletePath,
  buildGetGroupScheduleApiV2TimetablingGroupsGroupIdScheduleGetPath,
  buildGetStaffScheduleApiV2TimetablingStaffStaffIdScheduleGetPath,
  buildGetStudentScheduleApiV2TimetablingStudentsStudentIdScheduleGetPath,
  buildGetTimetableApiV2TimetablingTimetablesTimetableIdGetPath,
  buildGetTimetablesApiV2TimetablingTimetablesGetPath,
  buildGetTimetableStructureApiV2TimetablingStructuresStructureIdGetPath,
  buildGetTimetableStructuresApiV2TimetablingStructuresGetPath,
  buildModifyTimetableApiV2TimetablingTimetablesTimetableIdPatchPath,
  buildPerformTimetableActionApiV2TimetablingTimetablesTimetableIdActionPostPath,
  buildUpdateTimetableStructureApiV2TimetablingStructuresStructureIdPatchPath,
} from '../../generated/schooly-api-v2';

export const getTimetableStructuresPath =
  buildGetTimetableStructuresApiV2TimetablingStructuresGetPath;
export const getTimetableStructurePath =
  buildGetTimetableStructureApiV2TimetablingStructuresStructureIdGetPath;
export const createTimetableStructurePath =
  buildCreateTimetableStructureApiV2TimetablingStructuresPostPath;
export const updateTimetableStructurePath =
  buildUpdateTimetableStructureApiV2TimetablingStructuresStructureIdPatchPath;
export const deleteTimetableStructurePath =
  buildDeleteTimetableStructureApiV2TimetablingStructuresStructureIdDeletePath;

export const getTimetablesPath = buildGetTimetablesApiV2TimetablingTimetablesGetPath;
export const getTimetablePath = buildGetTimetableApiV2TimetablingTimetablesTimetableIdGetPath;
export const createTimetablePath = buildCreateTimetableApiV2TimetablingTimetablesPostPath;
export const modifyTimetablePath =
  buildModifyTimetableApiV2TimetablingTimetablesTimetableIdPatchPath;
export const deleteTimetablePath =
  buildDeleteTimetableApiV2TimetablingTimetablesTimetableIdDeletePath;
export const performTimetableActionPath =
  buildPerformTimetableActionApiV2TimetablingTimetablesTimetableIdActionPostPath;
export const getGroupSchedulePath =
  buildGetGroupScheduleApiV2TimetablingGroupsGroupIdScheduleGetPath;
export const getStudentSchedulePath =
  buildGetStudentScheduleApiV2TimetablingStudentsStudentIdScheduleGetPath;
export const getStaffSchedulePath =
  buildGetStaffScheduleApiV2TimetablingStaffStaffIdScheduleGetPath;
